import { render } from "./MilestoneBox.vue?vue&type=template&id=09a5bf4c"
import script from "./MilestoneBox.vue?vue&type=script&lang=js"
export * from "./MilestoneBox.vue?vue&type=script&lang=js"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__